let childEl = document.querySelector('.header__inline-menu > .list-menu')?.children;
for (var i = 0; i < childEl?.length; i++) {
  childEl[i].addEventListener('mouseover', function() {
  var isMega = this.querySelector('details');
    if (typeof(isMega) != 'undefined' && isMega != null) {
      this.querySelector('details').setAttribute('open','');
    }
  });
  childEl[i].addEventListener('mouseleave', function() {
    var isMega = this.querySelector('details');
    if (typeof(isMega) != 'undefined' && isMega != null) {
      this.querySelector('details').removeAttribute('open','');
    }
  });
};

const mobileFeaturedMenu = new Swiper('.mobile-featured-menu', {
  slidesPerView: 'auto',
  spaceBetween: 40,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  freeMode: true,
});